// extracted by mini-css-extract-plugin
export default {"container":"ViewTasks_container__SLoDv","containerChild":"ViewTasks_containerChild__xZYLK","whatsHappening":"ViewTasks_whatsHappening__NnDaJ","noTask":"ViewTasks_noTask__siOtw"};